import { FormattedMessage } from 'react-intl';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Cookies from 'universal-cookie';
import notificationPermissions from '@/enums/notificationPermissions';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

const cookie = new Cookies();
const COOKIE_MAX_AGE = 86400 * 180; // 180 days
const COOKIE_NAME = 'enableNotificationPrompt';
const COOKIE_BODY = 'dismissed';

type Props = {
    forceEnableNotificationsBanner: Function;
    hasNotifications: boolean;
    permission: string;
    requestBrowserPermission: Function;
};

type State = {
    dismissed: boolean;
};

export default class EnableNotificationPrompt extends PureComponent<Props, State> {
    state = {
        dismissed: false,
    };
    componentDidMount = () => {
        this.isBannerDismissed();
    };

    isBannerDismissed = () => {
        const hasBeenChecked = cookie.get(COOKIE_NAME);
        this.setState({ dismissed: COOKIE_BODY === hasBeenChecked });
        return COOKIE_BODY === hasBeenChecked;
    };

    onClickApprove = () => {
        if (this.props.permission === notificationPermissions.DENIED) {
            this.props.forceEnableNotificationsBanner();
        } else {
            this.props.requestBrowserPermission();
        }
    };

    onClickRiskIt = () => {
        cookie.set(COOKIE_NAME, COOKIE_BODY, { maxAge: COOKIE_MAX_AGE });
        this.setState({ dismissed: true });
    };

    render() {
        const { hasNotifications, permission } = this.props;
        if (this.state.dismissed || permission === notificationPermissions.GRANTED || !hasNotifications) {
            return null;
        }
        return (
            <>
                <StyledPromptContainer>
                    <StyledPromptTitle>
                        <FormattedMessage id="notifications.enable_notifications_prompt_title" />
                    </StyledPromptTitle>
                    <StyledPromptBody>
                        <FormattedMessage id="notifications.enable_notifications_prompt_body" />
                    </StyledPromptBody>
                    <StyledButtons>
                        <StyledButton onClick={this.onClickApprove} primary small>
                            <FormattedMessage id="notifications.yes" />
                        </StyledButton>
                        <StyledButton onClick={this.onClickRiskIt} secondary small>
                            <FormattedMessage id="notifications.risk_it" />
                        </StyledButton>
                    </StyledButtons>
                </StyledPromptContainer>
                <StyledContentBreak />
            </>
        );
    }
}

const StyledPromptContainer = styled.div`
    padding: 10px 18px 10px;
    text-align: center;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.5px;

    @media (max-width: 767px) {
        display: none;
    }
`;

const StyledPromptTitle = styled.div`
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    color: ${({ theme }) => theme.colors.black};
    line-height: 24px;
    letter-spacing: 0.5px;
    margin-top: 3px;
`;

const StyledPromptBody = styled.div`
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    color: ${({ theme }) => theme.colors.grey100};
`;

const StyledButtons = styled.div`
    display: flex;
    margin: 10px 0 10px;
    align-items: center;
    justify-content: center;
`;

const StyledButton = styled(Button).attrs(() => ({
    contentClassName: 'buttonContent',
}))`
    min-width: 94px;
    margin: 0 4px 0 4px;

    .buttonContent {
        align-items: center;
    }
`;

const StyledContentBreak = styled.hr`
    margin-top: 10px;
`;
